angular.module('impactx.oci').service('OCICatalogService', OCICatalogService);

OCICatalogService.$inject = ['$mdDialog', '$config', 'NewWindowService'];

function OCICatalogService($mdDialog, $config, NewWindowService) {

    function toExternalCat(catalog) {
        // OCI in UX is always in a new window!
        if (NewWindowService.check()) {
            if (catalog.showOCIConfirmationDialog) {
                $mdDialog.show({
                    templateUrl: "modules/oci/templates/oci-confirmation.tmpl.html",
                    controller: "OCIConfirmationCtrl",
                    controllerAs: "ociConfirmationCtrl",
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    locals: {
                        catalog: catalog
                    }
                });
            } else {
                window.location.href = $config.baseURL + "/oci/ocipage.jsp?CAT.Id=" + catalog.id + "&impactX=true";
            }
        }
    }

    return {
        toExternalCat: toExternalCat
    };
}